var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43164 5C9.43164 2.79086 7.64078 1 5.43164 1C3.2225 1 1.43164 2.79086 1.43164 5C1.43164 7.20914 3.2225 9 5.43164 9C6.79704 9 8.00265 8.31588 8.7244 7.27171L15.6636 10.6544C15.5134 11.0749 15.4316 11.5279 15.4316 12C15.4316 12.4395 15.5025 12.8624 15.6335 13.258L8.73405 16.7423C8.01342 15.6903 6.80314 15 5.43164 15C3.2225 15 1.43164 16.7909 1.43164 19C1.43164 21.2091 3.2225 23 5.43164 23C7.64078 23 9.43164 21.2091 9.43164 19C9.43164 18.8782 9.4262 18.7577 9.41555 18.6387L16.7265 14.9466C17.4386 15.6007 18.3885 16 19.4316 16C21.6408 16 23.4316 14.2091 23.4316 12C23.4316 9.79086 21.6408 8 19.4316 8C18.4254 8 17.506 8.37152 16.8031 8.98486L9.41357 5.38268C9.42553 5.25673 9.43164 5.12908 9.43164 5ZM3.43164 5C3.43164 3.89543 4.32707 3 5.43164 3C6.53621 3 7.43164 3.89543 7.43164 5C7.43164 6.10457 6.53621 7 5.43164 7C4.32707 7 3.43164 6.10457 3.43164 5ZM3.43164 19C3.43164 17.8954 4.32707 17 5.43164 17C6.53621 17 7.43164 17.8954 7.43164 19C7.43164 20.1046 6.53621 21 5.43164 21C4.32707 21 3.43164 20.1046 3.43164 19ZM19.4316 10C18.3271 10 17.4316 10.8954 17.4316 12C17.4316 13.1046 18.3271 14 19.4316 14C20.5362 14 21.4316 13.1046 21.4316 12C21.4316 10.8954 20.5362 10 19.4316 10Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePurple);
export default __webpack_public_path__ + "static/media/share-purple.441c4024bc05bbb1b33fcafaef4071d1.svg";
export { ForwardRef as ReactComponent };